import React from 'react';
import { NoDataIcon } from 'assets';
import styles from './style.module.scss';
import classNames from 'classnames';

function NotRecord({ ContainerStyle, IconStyle, Icon }) {
    return (
        <div className={classNames(ContainerStyle && ContainerStyle, 'd-flex flex-column justify-content-center  align-items-center w-100', styles.MainContainer)}>
            {Icon ? <Icon className={classNames(IconStyle && IconStyle, styles.NotFound)} /> : <NoDataIcon className={classNames(IconStyle && IconStyle, styles.NotFound)} />}
        </div>
    );
}

export default NotRecord;
